import React from "react";
import snakeCase from "lodash/snakeCase";
import camelCase from "lodash/camelCase";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

import labels from "../../constants/displayFields";
import Input from "../../components/form/Input";
import InputField from "../../components/form/InputField";
import { useProject } from "../../contexts/project";
import useAuth from "../../hooks/useAuth";

const nameField = name => camelCase(name);

const ORIGIN_STRING_FIELDS = [
  "existingBuilding",
  "existingRoom",
  "existingFloor",
  "originRoomNumber",
  "originEmployeeName",
  "originComments",
  "originCubbyNumber",
];

export default function FieldsOrigin({ fullWidth, display, disabledForm, asset }) {
  const sm = fullWidth ? 12 : 6;
  const currentProject = useProject();
  const { user } = useAuth();
  const { settings } = user.company;
  const onsiteInventoryCapture = currentProject?.settings?.onsite_inventory_capture;
  const availableQuantityLabel = settings.quantity_label || labels.available_quantity;
  const availableQuantityValue = asset?.availableQuantity ?? asset?.available_quantity;

  const buildFields = fields =>
    fields.reduce((result, key) => {
      const displayField = display[snakeCase(key)];
      return displayField ? [...result, snakeCase(key)] : result;
    }, []);

  const displaySection =
    display.existing_building ||
    display.existing_room ||
    display.existing_floor ||
    display.origin_room_number ||
    display.origin_employee_name ||
    display.origin_comments ||
    display.origin_cubby_number ||
    display.quantity ||
    display.department_name;

  return displaySection ? (
    <Card style={{ overflow: "visible" }}>
      <CardContent>
        <Box mt={-1} mb={1}>
          <Typography fontWeight={500} fontSize={18}>
            Origin
          </Typography>
        </Box>
        <Grid container spacing={1.5}>
          {buildFields(ORIGIN_STRING_FIELDS).map((fieldKey, index) => (
            <Grid key={`field-${index}`} size={12}>
              <Input
                type="autoExpand"
                name={nameField(fieldKey)}
                label={labels[fieldKey]}
                disabled={disabledForm}
              />
            </Grid>
          ))}
          {display.quantity && (
            <Grid size={{ xs: 12, sm: sm }}>
              <Input
                type="number"
                name={nameField("quantity")}
                label={labels.quantity}
                disabled={disabledForm}
                showNAButton={false}
              />
            </Grid>
          )}
          {display.quantity && onsiteInventoryCapture && (
            <Grid size={{ xs: 12, sm: sm }}>
              <InputField
                type="number"
                label={availableQuantityLabel}
                value={availableQuantityValue ?? ""}
                disabled
                size="small"
                variant="outlined"
                margin="none"
                InputProps={{ readOnly: true }}
              />
            </Grid>
          )}
          {display.department_name && (
            <Grid size={12}>
              <Input
                type="autoExpand"
                name={nameField("department_name")}
                label={labels.department_name}
                disabled={disabledForm}
              />
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  ) : null;
}
